import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { formatApiError } from "../lib/api";
import Logo from "../components/Logo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user && user !== false) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(username.trim(), password);
      nav("/admin", { replace: true });
    } catch (e) {
      setErr(formatApiError(e?.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[color:var(--nt-sky-soft)] flex items-center justify-center p-4">
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-white rounded-2xl shadow-lg p-6 sm:p-8"
        data-testid="admin-login-form"
      >
        <div className="flex flex-col items-center mb-6">
          <Logo size={68} />
          <h1 className="font-display text-2xl mt-3">Admin Login</h1>
          <p className="text-slate-600 text-sm">Night Teer Control Panel</p>
        </div>

        <label className="block text-sm font-bold mb-1">Username</label>
        <input
          data-testid="admin-username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="w-full rounded-lg border-2 border-slate-300 px-3 py-2 mb-3 focus:outline-none focus:border-emerald-500"
          autoFocus
          required
        />

        <label className="block text-sm font-bold mb-1">Password</label>
        <input
          data-testid="admin-password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full rounded-lg border-2 border-slate-300 px-3 py-2 mb-4 focus:outline-none focus:border-emerald-500"
          required
        />

        {err ? (
          <div
            data-testid="login-error"
            className="mb-3 text-sm text-red-600 font-semibold"
          >
            {err}
          </div>
        ) : null}

        <button
          type="submit"
          disabled={busy}
          data-testid="admin-login-submit"
          className="nt-btn nt-btn-ink w-full py-3 disabled:opacity-60"
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>

        <div className="text-center mt-4 text-xs text-slate-500">
          <a href="/" className="hover:underline">← Back to site</a>
        </div>
      </form>
    </div>
  );
}
